import { render } from "./applyAfterSales.vue?vue&type=template&id=dd476b70&scoped=true"
import script from "./applyAfterSales.vue?vue&type=script&lang=js"
export * from "./applyAfterSales.vue?vue&type=script&lang=js"

import "./applyAfterSales.vue?vue&type=style&index=0&id=dd476b70&lang=less&scoped=true"
import "./applyAfterSales.vue?vue&type=style&index=1&id=dd476b70&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd476b70"]])

export default __exports__